// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-c37f3fb2] .privacy-statement-component-subject-title{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
